module.exports = __webpack_public_path__ + "img/kplay_esport.5fca9ee0.jpeg";